import { MagnusLogo } from "./Logo";
import {
    NAV_LINKS,
    CONTACT,
    scrollToId,
    waLink,
    DEFAULT_WA_MSG,
} from "../lib/site";

export default function Footer() {
    return (
        <footer className="bg-obsidian text-cream pt-16 sm:pt-20 pb-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <MagnusLogo light size="w-12" />
                        <p className="font-display italic text-2xl text-gold mt-6">
                            "Personalize seu presente!"
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="font-accent text-[10px] uppercase tracking-[0.3em] text-gold">
                            Navegação
                        </p>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.id}>
                                    <button
                                        data-testid={`footer-link-${l.id}`}
                                        onClick={() => scrollToId(l.id)}
                                        className="font-body text-sm text-cream/70 hover:text-gold transition-colors"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="font-accent text-[10px] uppercase tracking-[0.3em] text-gold">
                            Contato
                        </p>
                        <ul className="mt-5 space-y-3">
                            <li>
                                <a
                                    data-testid="footer-instagram-link"
                                    href={CONTACT.instagramUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-body text-sm text-cream/70 hover:text-gold transition-colors"
                                >
                                    {CONTACT.instagram}
                                </a>
                            </li>
                            <li>
                                <a
                                    data-testid="footer-whatsapp-link"
                                    href={waLink(DEFAULT_WA_MSG)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-body text-sm text-cream/70 hover:text-gold transition-colors"
                                >
                                    {CONTACT.whatsappDisplay}
                                </a>
                            </li>
                            <li>
                                <a
                                    data-testid="footer-email-link"
                                    href={`mailto:${CONTACT.email}`}
                                    className="font-body text-sm text-cream/70 hover:text-gold transition-colors break-all"
                                >
                                    {CONTACT.email}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="hairline-gold mt-14 opacity-40" />
                <p className="font-body text-xs text-cream/45 mt-8">
                    © {new Date().getFullYear()} Magnus Personalizados — CNPJ{" "}
                    {CONTACT.cnpj}
                </p>
            </div>
        </footer>
    );
}
